import { useTranslation } from 'react-i18next';
import { SubscriptionPlansSectionProp } from './props';
import { getCurrencySymbol } from '../../utils';
import InfoIcon from '../../../../../assets/svg/info.svg';
import { SubscriptionPlanType } from '../../../../../utils/utilTypes';
import { usePaymentPlanDetailsSlice } from '../../../../../slices/usePaymentPlanDetailsSlice';

export const SubscriptionsPlansSection = ({
  subscriptionPlans,
  userSubscriptions,
  selectedSubscriptionPlan,
  userHasActiveSubscriptionPlan,
  onSelect,
}: SubscriptionPlansSectionProp) => {
  const { t } = useTranslation();
  const { handleSelectPlan } = usePaymentPlanDetailsSlice();

  const onPickSubscriptionPlan = (subscriptionPlan: SubscriptionPlanType) => {
    if (
      selectedSubscriptionPlan === subscriptionPlan.id ||
      userHasActiveSubscriptionPlan
    ) {
      return;
    }

    onSelect(subscriptionPlan.id);
  };

  const handleShowInfoClick = (subscription: SubscriptionPlanType) => {
    handleSelectPlan(subscription);
  };

  if (subscriptionPlans.length === 0) {
    return null;
  }

  return (
    <div className="flex flex-col my-1">
      <div>
        {subscriptionPlans?.length > 0 && (
          <div className="text-xs font-bold font-mono">
            {t('subscriptions.cardTitle')}
          </div>
        )}
      </div>
      <div className="flex flex-row overflow-x-scroll gap-1 py-2">
        {subscriptionPlans
          .map((sp) => {
            const isActive = userSubscriptions.some((sub: any) => {
              return (
                sub.metadata.subscriptionPlanId === sp.id &&
                sub.status === 'active'
              );
            });

            return {
              ...sp,
              isActive,
            };
          })
          .sort((a, b) => {
            if (a.isActive) return -1;
            if (b.isActive) return 1;
            return 0;
          })
          .map((sp) => {
            const isSelected = selectedSubscriptionPlan === sp.id;
            return (
              <div
                key={sp.id}
                className={`flex flex-col  grow-0 items-start border p-2 rounded-md shrink-0 ${
                  isSelected ? 'bg-primary text-white' : 'border-gray-300'
                } ${sp.isActive && 'border-2 border-green-600'}`}
                onClick={() => onPickSubscriptionPlan(sp)}
              >
                <div className="flex items-center gap-4">
                  <div className="flex flex-col">
                    <div className="flex gap-2">
                      <div className="text-xs font-bold shrink-0">
                        {sp.name}
                      </div>
                    </div>
                    <div className="text-xs">
                      {sp.price}{' '}
                      {getCurrencySymbol(String(sp.currency.toLowerCase()))} /{' '}
                      {t(`subscriptions.interval.${sp.interval}`)}{' '}
                      {sp.isActive && '✅'}
                    </div>
                  </div>
                  <div
                    className="w-5 h-5 active:opacity-50"
                    onClick={() => handleShowInfoClick(sp)}
                  >
                    <InfoIcon />
                  </div>
                </div>
              </div>
            );
          })}
      </div>
    </div>
  );
};
